import ottImage from "./OttBanner.jpeg";
import indoreBanner from "./indoreBanner.jpeg";
import edBanner from "./edBanner.jpeg";

const sliderArrayMobile = [
  {
    index: 0,
    img: ottImage,
  },
  {
    index: 1,
    img: indoreBanner,
  },
  {
    index: 2,
    img: edBanner,
  },
];

export default sliderArrayMobile;
